import '.bn{position:relative;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.g6{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.c4{align-items:flex-start;}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.ci{background:var(--shades-white);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.m{position:absolute;}.ssr-plugin'
import '.is{top:50%;}.ssr-plugin'
import '.it{right:1rem;}.ssr-plugin'
import '.iu{transform:translateY(-50%);}.ssr-plugin'
import '.iv{width:120px;}.ssr-plugin'
import '.iw{height:120px;}.ssr-plugin'
import '.ix{z-index:0;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.hu{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.iy{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bn z g6 a e b c4 s ci q"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="m is it iu iv iw ix a f b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bn hu a e c4 aj iy"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
